import { useAtomValue } from 'jotai';
import * as state from '../../state';

export const useAssemblyCadModelsBasePath = () => {
  const inspectionMetadata = useAtomValue(state.inspectionMetadata);
  const assemblyCadModelsBasePath = inspectionMetadata?.assemblyCadModelsBasePath;
  return { assemblyCadModelsBasePath, hasAssemblyCadModels: !!assemblyCadModelsBasePath };
};
